import React from 'react'
// components
import ReviewResult from 'components/Modals/PlanItems/components/ReviewsList/components/ReviewResult'
// context
import ReviewsListBL from 'containers/Review/ReviewList/layers/BL/index'

const ReviewResultContainer = props => {
  return (
    <ReviewsListBL {...props}>
      <ReviewResult {...props} />
    </ReviewsListBL>
  )
}
export default ReviewResultContainer
